<nz-form-item *ngIf="formGroup?.get([this.fieldName])" [formGroup]="formGroup" style="margin: 0">
  <nz-radio-group [formControlName]="fieldName">
    <label nz-radio *ngFor="let option of options" [nzValue]="option.value">{{ option.label }}</label>
  </nz-radio-group>
</nz-form-item>
